'use client';

import 'client-only';

import Toggle from '@components/toggle';
import { THEME_DARK, THEME_LIGHT } from 'constants/themes';
import { useTheme } from 'lib/next-themes';
import type { ReactElement } from 'react';
import { useCallback, useEffect, useState } from 'react';
import { validateString } from 'utils/validate-string';

import styles from './theme-toggler.module.scss';

const rootClass = validateString(styles.root);
const iconClass = validateString(styles.icon);
const skeletonClass = validateString(styles.skeleton);

function ThemeToggler(): ReactElement {
  const [mounted, setMounted] = useState(false);
  const { resolvedTheme, setTheme } = useTheme();

  // useEffect only runs on the client, so now we can safely use the theme
  useEffect(() => {
    setMounted(true);
  }, []);

  const onClick = useCallback(() => {
    const nextTheme =
      resolvedTheme === THEME_LIGHT || typeof resolvedTheme === 'undefined'
        ? THEME_DARK
        : THEME_LIGHT;
    // console.log('Theme Toggle clicked', {
    //   themeState: theme,
    //   resolvedTheme,
    //   nextTheme: nextTheme,
    //   availableThemes: themes,
    //   setTheme: setTheme,
    //   altTheme: altTheme,
    //   altSetTheme: altSetTheme,
    // });

    setTheme(nextTheme);
  }, [setTheme, resolvedTheme]);

  if (!mounted) {
    return <div className={skeletonClass} />;
  }

  return (
    <Toggle
      aria-label="Dark mode toggle"
      className={rootClass}
      onClick={onClick}
      pressed={resolvedTheme === THEME_DARK}
    >
      <span className={iconClass} />
    </Toggle>
  );
}

export default ThemeToggler;
